import styled from 'styled-components';
import { breakpoints } from '@chegg-ui/theme';
function getContainerWidth(itemsInRow) {
  if (itemsInRow == 1) {
    return "\n      @media (max-width: ".concat(breakpoints.sm.max, ") {\n        width: 100%;\n      }\n      @media (min-width: ").concat(breakpoints.sm.max, ") {\n        width: 100%;\n      }\n    ");
  } else if (itemsInRow == 2) {
    return "\n      @media (max-width: ".concat(breakpoints.sm.max, ") {\n        width: 100%;\n      }\n      @media (min-width: ").concat(breakpoints.sm.max, ") {\n        width: 49%;\n        min-width: 175px;\n      }\n    ");
  } else if (itemsInRow == 3) {
    return "\n      @media (max-width: ".concat(breakpoints.sm.max, ") {\n        width: 100%;\n      }\n      @media (min-width: ").concat(breakpoints.sm.max, ") {\n        width: 33%;\n        min-width: 160px;\n      }\n      @media (min-width: ").concat(breakpoints.lg.min, ") and (max-width: ").concat(breakpoints.lg.max, "){\n        width: 100%;\n      }\n    ");
  } else if (itemsInRow == 4) {
    return "\n      @media (max-width: 400px) {\n        width: 100%;\n      }\n      @media (min-width: 400px) {\n        width: 49%;\n        min-width: 160px;\n      }\n    ";
  } else {
    return "\n      min-width: 106px;\n    ";
  }
}
export var ThirdPartyButtonContainer = styled.div.withConfig({
  componentId: "sc-14vhcx9-0"
})(["", ";height:44px;margin-bottom:10px;min-width:130px;"], function (props) {
  return getContainerWidth(props.itemsInRow);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/PaymentButtons/ThirdPartyButtonContainer.js
// module id = 1499
// module chunks = 11